const LOCAL_HOSTS = new Set(["localhost", "127.0.0.1", "::1"]);

export const resolveApiBaseUrl = () => {
  const configuredUrl = import.meta.env.VITE_API_BASE_URL || "";
  if (!configuredUrl || typeof window === "undefined") {
    return configuredUrl;
  }

  try {
    const url = new URL(configuredUrl);
    const pageHost = window.location.hostname;

    if (!LOCAL_HOSTS.has(pageHost) && LOCAL_HOSTS.has(url.hostname)) {
      url.hostname = pageHost;
      return url.toString().replace(/\/$/, "");
    }

    return configuredUrl.replace(/\/$/, "");
  } catch {
    return configuredUrl.replace(/\/$/, "");
  }
};

export const resolveScoringAppUrl = (accessToken = "") => {
  const configuredUrl = import.meta.env.VITE_API_BASE_URL || "";
  let baseUrl = configuredUrl;

  if (!baseUrl && typeof window !== "undefined") {
    const pageHost = window.location.hostname;
    if (LOCAL_HOSTS.has(pageHost)) {
      baseUrl = "http://localhost:3000";
    } else {
      baseUrl = window.location.origin;
    }
  }

  if (!baseUrl) {
    baseUrl = "https://dev-global.zaira.com.np";
  }

  const cleanBase = baseUrl.replace(/\/$/, "");
  const targetPath = `${cleanBase}/admin/service-providers`;
  if (!accessToken) return targetPath;

  return `${targetPath}?token=${encodeURIComponent(accessToken)}`;
};

export const resolveScoringProviderProfileUrl = (entityId = "", accessToken = "") => {
  const configuredUrl = import.meta.env.VITE_API_BASE_URL || "";
  let baseUrl = configuredUrl;

  if (!baseUrl && typeof window !== "undefined") {
    const pageHost = window.location.hostname;
    if (LOCAL_HOSTS.has(pageHost)) {
      baseUrl = "http://localhost:3000";
    } else {
      baseUrl = window.location.origin;
    }
  }

  if (!baseUrl) {
    baseUrl = "https://dev-global.zaira.com.np";
  }

  const cleanBase = baseUrl.replace(/\/$/, "");
  const basePath = entityId
    ? `${cleanBase}/admin/service-providers?id=${encodeURIComponent(entityId)}`
    : `${cleanBase}/admin/service-providers`;

  if (!accessToken) return basePath;
  return `${basePath}&token=${encodeURIComponent(accessToken)}`;
};
